<template>
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form>
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="类型名称" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input
                  v-model="table.search.typeName"
                  placeholder="请输入投诉类型"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="{ float: 'left', overflow: 'hidden' } || {}"
              >
                <a-button type="primary" @click="toSearch">查询</a-button>
                <a-button
                  style="margin-left: 8px; font-style: italic"
                  @click="resetSearch"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" style="margin: 20px 0">
        <a-button type="primary" icon="plus" @click="createType"
          >新增类型</a-button
        >
      </div>
      <a-spin tip="加载中..." :spinning="table.loading">
        <!-- 表格 -->
        <a-table
          :columns="columns"
          :data-source="table.data"
          rowKey="id"
          :pagination="table.page"
          @change="handlePageChange"
        >
          <span slot="status" slot-scope="data">
            <div>
              <a-switch
                :checked="data.status == 1"
                @change="setComplaintTypeStatus(data)"
              />
            </div>
          </span>
          <span slot="action" slot-scope="text, data">
            <template>
              <a @click="handleEdit(data)">编辑</a>
              <!-- <a-divider type="vertical" />
              <a @click="handleDelete(data)">查看子集</a> -->
              <a-divider type="vertical" />
              <a @click="handleDelete(data)">删除</a>
            </template>
          </span>
        </a-table>
      </a-spin>

      <a-modal
        :title="modal.title"
        :confirm-loading="modal.loading"
        v-model="modal.show"
        @ok="confirmModal"
        destroy-on-close
        centered
      >
        <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
          <!-- <a-form-model-item label="父级类型" v-if="modal.type == 0">
            <a-cascader
              :options="typeOptions"
              placeholder="请选择父级类型"
              v-model="form.fatherTypeIds"
              change-on-select
            />
          </a-form-model-item> -->
          <a-form-model-item label="类型名称">
            <a-input v-model="form.typeName"></a-input>
          </a-form-model-item>
          <a-form-model-item label="类型说明">
            <a-input v-model="form.remarks"></a-input>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import ComplaintTypeService from "@/io/complaint/complaintType.js";

export default {
  name: "ComplaintType",
  data() {
    let self = this;
    return {
      testOptions: [
        {
          id: 2,
          name: "安全秩序",
          remarks: "备注信息一",
          status: 1,
          pid: 0,
          child: [
            {
              id: 7,
              pid: 2,
              name: "投诉类型一",
              remarks: "备注信息1",
              status: 0,
              child: [],
            },
          ],
        },
        {
          id: 3,
          name: "车辆管理",
          remarks: "备注信息二",
          status: 1,
          pid: 0,
          child: [
            {
              id: 8,
              pid: 3,
              name: "投诉类型二",
              remarks: "备注信息2",
              status: 1,
              child: [],
            },
          ],
        },
      ],
      typeOptions: [],
      // create model
      modal: {
        show: false,
        loading: false,
        // 0新增，1编辑
        type: 0,
      },
      rules: {},
      form: {
        typeName: null,
        remarks: null,
        id: null,
        fatherTypeIds: [],
      },
      columns: [
        {
          title: "类型ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "类型名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "类型说明",
          dataIndex: "remarks",
          key: "remarks",
        },
        {
          title: "状态",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      table: {
        editData: {
          typeName: null,
          remarks: null,
        },
        loading: false,
        data: [],
        search: {
          typeName: null,
        },
        page: {
          total: 0,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          },
        },
      },
    };
  },
  mounted() {
    this.getTypeList();

  },
  methods: {
    //   获取类型列表(type=0时为列表，1为下拉框)
    async getTypeList() {
    //   this.table.loading = true;
      const { page, search } = this.table;
      const res = await ComplaintTypeService.list(
        search.typeName,
        page.current,
        page.pageSize
      );
      //   将分类添加进入typeOptions
        this.typeOptions = this.getTypeOptions(res.data);
        // this.typeOptions = this.getTypeOptions(this.testOptions);
        this.table.data = res.data
        this.table.page.total = res.meta.pagination.total
    },
    // 生成分类数据
    getTypeOptions(data) {
      let reslist = [];
      data.map( val => {
        reslist.push({
          value: val.id,
          label: val.name,
          children: val.child.length > 0 ? this.getTypeOptions(val.child) : [],
        });
      });
      return reslist;
    },
    //   更改状态
    async setComplaintTypeStatus({ id, status }) {
      //   ComplaintTypeService.edit()
      // let resStatus = status == 1 ? 0 : 1;
      const res = await ComplaintTypeService.status(id);
      // 更改为展示多级，递归查太麻烦了，先刷新列表
      // let index = this.table.data.findIndex((val) => {
      //   return val.id == id;
      // });
      // this.table.data[index].status = resStatus;
      this.getTypeList()
    },
    // 编辑
    handleEdit(data) {
      this.modal.type = 1;
      this.modal.show = true;
      this.form.typeName = data.name;
      this.form.remarks = data.remarks;
      this.form.id = data.id;
    },
    // 新建
    createType() {
      this.modal.type = 0;
      this.modal.show = true;
      this.form.typeName = null;
      this.form.remarks = null;
      this.form.id = null;
      this.form.fatherTypeIds = [];
    },
    // 提交
    confirmModal() {
      this.$beforeFormSubmit(this.$refs.form, async () => {
        // 新增
        // let resFid = this.form.fatherTypeIds[this.form.fatherTypeIds.length - 1] || 0;
        if (this.modal.type == 0) {
          await ComplaintTypeService.add(
            // resFid,
            0,
            this.form.typeName,
            this.form.remarks
          );
          this.$afterFormSubmit("创建成功", () => {
            this.getTypeList();
            this.modal.show = false;
            this.modal.loading = false;
          });
        } else {
          await ComplaintTypeService.edit(
            this.form.id,
            this.form.typeName,
            this.form.remarks
          );
          this.$afterFormSubmit("修改成功", () => {
            this.getTypeList();
            this.modal.show = false;
          });
        }
      });
    },
    // 删除类型
    async handleDelete({ id }) {
      const res = await ComplaintTypeService.delete(id);
      this.$message.info(res.msg);
      this.getTypeList();
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.getTypeList();
    },
    // 搜索
    toSearch() {
      this.table.page.current = 1;
      this.getTypeList();
    },
    // 重置
    resetSearch() {
      this.table.search.typeName = null;
      this.toSearch()
    },
  },
};
</script>
